import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../request/request";

export const getReportDetails = createAsyncThunk(
  "reportDetails",
  async (object, { rejectWithValue }) => {
    const { tenantId } = object;
    let url = `/api/v1/tenant-report-details/${tenantId}`;
    const response = await request(url, { method: "GET", auth: true });
    if (response) {
      return response;
    }
    const { error } = response;
    throw rejectWithValue(error || "Something went wrong");
  }
);
